// eslint-disable-next-line no-restricted-imports
import { GlobalFinancialMonitoringInfoFragment } from 'api/generated/graphql';
import { LegalClientGlobalFinancialMonitoringInfoEntity } from 'api/types/entity';
import { Maybe } from 'types/maybe';

export const parseGlobalFinancialMonitoringEntity = (
  data?: Maybe<GlobalFinancialMonitoringInfoFragment>
): LegalClientGlobalFinancialMonitoringInfoEntity | undefined =>
  data
    ? {
        partOne: data.partOne
          ? {
              supervisoryAuthorityNameAndLocation:
                data.partOne.supervisoryAuthorityNameAndLocation,
              mandatoryAmlRegulation: {
                hasMandatoryAmlRegulations:
                  data.partOne.hasMandatoryAmlRegulations,
                authorizedBodyName:
                  data.partOne.mandatoryAmlRegulation?.authorizedBodyName,
                regulationDetails:
                  data.partOne.mandatoryAmlRegulation?.regulationDetails,
              },
              lastAmlAuditResult: data.partOne.lastAmlAuditResult ?? undefined,
              investigationsOrSanctions: {
                hadInvestigationsOrSanctions:
                  data.partOne.hadInvestigationsOrSanctions,
                amlDecisionDateAndAuthorityInfo:
                  data.partOne.amlDecisionDateAndAuthorityInfo ?? undefined,
              },

              internalAmlDocuments: {
                hasInternalAmlDocuments: data.partOne.hasInternalAmlDocuments,

                adoptionDate: data.partOne.internalAmlDocuments?.adoptionDate
                  ? new Date(data.partOne.internalAmlDocuments?.adoptionDate)
                  : undefined,

                lastUpdateDate: data.partOne.internalAmlDocuments
                  ?.lastUpdateDate
                  ? new Date(data.partOne.internalAmlDocuments?.lastUpdateDate)
                  : undefined,

                hasEffectivenessAssessmentProcedures:
                  data.partOne.internalAmlDocuments
                    ?.hasEffectivenessAssessmentProcedures,
                lastEffectivenessCheckInfo:
                  data.partOne.internalAmlDocuments
                    ?.lastEffectivenessCheckInfo ?? undefined,
                appliesToForeignAffiliates:
                  data.partOne.internalAmlDocuments
                    ?.appliesToForeignAffiliates ?? undefined,
              },

              departmentsResponsibleForAmlFunctions: {
                hasDepartmentsResponsibleForAmlFunctions:
                  data.partOne.hasDepartmentsResponsibleForAmlFunctions,
                amlFunctionDepartmentsNames:
                  data.partOne.amlFunctionDepartmentsNames ?? undefined,
              },
              responsibleAmlManager: {
                hasResponsibleAmlManager: data.partOne.hasResponsibleAmlManager,
                fullName:
                  data.partOne.responsibleAmlManager?.fullName ?? undefined,
                position:
                  data.partOne.responsibleAmlManager?.position ?? undefined,
                email: data.partOne.responsibleAmlManager?.email ?? undefined,
                phoneNumber:
                  data.partOne.responsibleAmlManager?.phoneNumber ?? undefined,
              },
              hasRiskManagementProcedures:
                data.partOne.hasRiskManagementProcedures,
            }
          : undefined,

        partTwo: data.partTwo
          ? {
              hasSourceOfFundsProcedures:
                data.partTwo.hasSourceOfFundsProcedures,
              hasRelationshipsWithPEPProcedures:
                data.partTwo.hasRelationshipsWithPEPProcedures,
              hasAnonymousAccounts: data.partTwo.hasAnonymousAccounts,
              hasAnonymousAccountPreventionProcedures:
                data.partTwo.hasAnonymousAccountPreventionProcedures,
              hasTransactionMonitoringProcedures:
                data.partTwo.hasTransactionMonitoringProcedures,
              hasAssetFreezingProcedures:
                data.partTwo.hasAssetFreezingProcedures,
              hasAMLTrainingProcedures: data.partTwo.hasAMLTrainingProcedures,
              amlTrainingDetails: data.partTwo.amlTrainingDetails ?? undefined,
              hasBranchesInNonFATFCountries:
                data.partTwo.hasBranchesInNonFATFCountries,
              nonFATFBranchesNamesAndLocations:
                data.partTwo.nonFATFBranchesNamesAndLocations ?? undefined,
              hasCorrespondentsInNonFATFCountries:
                data.partTwo.hasCorrespondentsInNonFATFCountries,
              nonFATFCorrespondentsNames:
                data.partTwo.nonFATFCorrespondentsNames ?? undefined,
              hasCorrespondentsInOffshoreZones:
                data.partTwo.hasCorrespondentsInOffshoreZones,
              offshoreCorrespondentsNames:
                data.partTwo.offshoreCorrespondentsNames ?? undefined,
              hasShellBankRelationships: data.partTwo.hasShellBankRelationships,
              shellBanksNames: data.partTwo.shellBanksNames ?? undefined,
              hasShellBankPreventionProcedures:
                data.partTwo.hasShellBankPreventionProcedures,
              hasCDDRequestComplianceProcedures:
                data.partTwo.hasCDDRequestComplianceProcedures,
              creditRating: data.partTwo.creditRating ?? undefined,
              subsidiariesNamesAndLocations:
                data.partTwo.subsidiariesNamesAndLocations ?? undefined,
              keyPartnersNames: data.partTwo.keyPartnersNames ?? undefined,
              foreignBranchesNamesAndLocations:
                data.partTwo.foreignBranchesNamesAndLocations ?? undefined,
              financialGroupInfo: data.partTwo.financialGroupInfo ?? undefined,
              hasSanctionPolicyDocuments:
                data.partTwo.hasSanctionPolicyDocuments,
              hasSanctionsMonitoringProcedures:
                data.partTwo.hasSanctionsMonitoringProcedures,
              isUnderSanctionsOrControlledBySanctionedEntity:
                data.partTwo.isUnderSanctionsOrControlledBySanctionedEntity,
              isListedInSanctionLists: data.partTwo.isListedInSanctionLists,
              isLinkedToSanctionedEntities:
                data.partTwo.isLinkedToSanctionedEntities,
            }
          : undefined,
      }
    : undefined;
